/* eslint-disabled */
import Action from "./Action";
import Item from "./Item";
import Trigger from "./Trigger";
import CampaignExtend from "@/entity/extends/CampaignExtend";
import { hydrateCollection } from "@/Utils/EntityHelper";

export default class Campaign extends CampaignExtend {

    public id!: number;
    public name = '';
    public description? = '';
    public code = '';
    public actions: Array<Action> = [];
    public items: Array<Item> = [];
    public triggers: Array<Trigger> = [];

    constructor (object?: any) {
        super(object)
        if(object){
            this.id= object.id;
            this.name= object.name;
            this.description= object.description;
            this.code= object.code;
            hydrateCollection(object.actions, Action, this.actions);
            hydrateCollection(object.items, Item, this.items);
            hydrateCollection(object.triggers, Trigger, this.triggers);
        }
        this.postConstruct()
    }

}
